import { Link } from 'react-router-dom';

export default function MarketplaceNewPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="rounded-lg border bg-card p-8 shadow-sm">
          <div className="mb-6">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-green-500/10 text-green-600 dark:text-green-400 mb-4">
              GREEN CHECK REQUIRED
            </span>
            <h1 className="text-3xl font-bold mb-2">New Marketplace Listing</h1>
            <p className="text-muted-foreground">
              Create a new listing in the marketplace. This feature requires Green Check verification.
            </p>
          </div>

          <div className="space-y-4 mb-6">
            <div className="p-4 rounded-md bg-muted/50">
              <h3 className="font-semibold mb-1">What you can do here:</h3>
              <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
                <li>List products or services for sale</li>
                <li>Set pricing and availability</li>
                <li>Add photos and descriptions</li>
                <li>Manage your listings</li>
              </ul>
            </div>

            <div className="p-4 rounded-md border-l-4 border-amber-500 bg-amber-500/5">
              <p className="text-sm font-medium text-amber-900 dark:text-amber-200">
                🔒 This feature is currently in development and requires Green Check verification.
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            <Link 
              to="/"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
            >
              Back to Home
            </Link>
            <button 
              disabled
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
            >
              Create Listing (Coming Soon)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
